<template>
  <b-modal
        scrollable
    id="complete-order"
    ref="modal"
    header-class="headerModal"
    centered
    size="s"
    :title="`${this.$t('CompleteThisOrder')}: ${completeOrder?.deliveryNumber}`"
    hide-footer
    @hide="onCancel"
  >
    <p> {{ $t('AreUSureDelivery') }}</p>
    <div class="buttonsEverywhere">
      <b-button
        type="button"
        variant="none"
        class="buttonSubmit"

        @click="onSubmit"
      >
        {{ $t('Submit') }}
      </b-button>
      <b-button
        type="button"
        variant="danger"
        class="buttonCancel"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';


export default {
  components: {
  },
  props: ['completeOrder'],
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {

  },
  methods: {
    ...mapActions([]),

    async onSubmit() {
      this.$emit('completeTheOrder', this.completeOrder?.deliveryManagementId)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.$refs.modal.hide()
    },
  },
}
</script>

  <style lang="scss" scoped>

  </style>
